import {
  getBasePayRate,
  getGrandTotal,
  getIncomeItem,
  getMemberRecords,
  getTotalByFieldName,
  getUniqueMemberIds,
} from './incomeTotals.utils';

export const getIncome = (fieldId, labelId, records) => {
  if (!records || !records?.length) {
    return {
      [fieldId]: [],
      totalIncome: 0,
    };
  }

  // Get unique memberIds
  const memberIds = getUniqueMemberIds(records);

  // Process records for each member
  const memberIncomes = memberIds.map((memberId) => {
    const memberRecords = getMemberRecords(records, memberId);

    const incomeItems = [];

    memberRecords.forEach((record) => {
      const {
        payFrequency,
        weeklyAmount,
        monthlyAmount,
        annualAmount,
        source,
      } = record;

      // Get base pay rate from appropriate field
      const basePayRate = getBasePayRate({
        payFrequency,
        weeklyAmount,
        monthlyAmount,
        annualAmount,
      });

      // Skip if no amount
      if (!basePayRate) {
        return;
      }

      incomeItems.push({
        ...record,
        ...getIncomeItem({
          memberId,
          payType: source || labelId,
          payFrequency,
          payRate: basePayRate,
        }),
      });
    });

    // Calculate member's total income
    const memberTotalIncome = getTotalByFieldName(incomeItems, 'incomeTotal');

    return {
      memberId,
      [fieldId]: incomeItems,
      totalIncome: memberTotalIncome,
    };
  });

  return getGrandTotal({
    items: memberIncomes,
    fieldId,
  });
};
